module.exports = __webpack_public_path__ + "static/mujeres002-0f631c2b7df9bdd2def819a20dedb56b.jpg";